// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { CascaderTokens } from './type';

const cascaderTokens: CascaderTokens = {
  cascaderWidth: 'Size-120',
  cascaderFontSize: '14/regular',
  cascaderFontColor: 'Neutral-text-5',
  cascaderBorderRadius: 'Radius-4',
  cascaderBorderColor: 'Neutral-border-2',
  cascaderPaddingX: 'Padding-8',
  cascaderPaddingY: 'Padding-2',
  cascaderIconSize: 'Size-7',
  cascaderIconColor: 'Neutral-text-4',
  cascaderSmallFontSize: '12/regular',
  cascaderSmallPaddingX: 'Padding-8',
  cascaderSmallPaddingY: 'Padding-1',
  cascaderSmallOptionInnerPaddingX: 'Padding-8',
  cascaderSmallOptionInnerPaddingY: 'Padding-2',
  cascaderLargeFontSize: '16/regular',
  cascaderLargePaddingX: 'Padding-12',
  cascaderLargePaddingY: 'Padding-3',
  cascaderLargeOptionInnerPaddingX: 'Padding-12',
  cascaderLargeOptionInnerPaddingY: 'Padding-8',
  cascaderLargePlaceholderMarginY: 'Padding-4',
  cascaderInnerPaddingX: 'Padding-8',
  cascaderInnerPaddingY: 'Padding-5',
  cascaderPlaceholderColor: 'Neutral-text-2',
  cascaderPlaceholderMarginY: 'Padding-2',
  cascaderBackgroundColor: 'Neutral-fill-1',
  cascaderClearColor: 'Neutral-text-3',
  cascaderClearPadding: 'Padding-8',
  cascaderClearHoverColor: 'Neutral-text-4',
  cascaderHoverBorderColor: 'Brand-6',
  cascaderHoverClearColor: 'Neutral-text-4',
  cascaderFocusBorderColor: 'Brand-7',
  cascaderFocusShadow: 'Brand-2',
  cascaderDisabledFontColor: 'Neutral-text-2',
  cascaderDisabledPlaceholderColor: 'Neutral-text-2',
  cascaderDisabledBorderColor: 'Neutral-border-2',
  cascaderDisabledBackgroundColor: 'Neutral-fill-2',
  cascaderResultTextBorderRadius: 'Radius-4',
  cascaderResultTextPaddingX: 'Padding-4',
  cascaderResultTextSmallPaddingX: 'Padding-4',
  cascaderResultTextLargePaddingX: 'Padding-10',
  cascaderResultTextActiveBackgroundColor: 'Brand-1',
  cascaderResultItemHoverColor: 'Brand-5',
  cascaderResultItemActiveColor: 'Brand-7',
  cascaderResultItemCheckedColor: 'Brand-6',
  cascaderErrorBorderColor: 'Danger-6',
  cascaderErrorFocusShadow: 'Danger-1',
  cascaderPanelColor: 'Neutral-text-5',
  cascaderPanelBackgroundColor: 'Neutral-fill-1',
  cascaderPanelShadow: 'Shadow-2',
  cascaderPanelRadius: 'Radius-4',
  cascaderPanelBorder: 'Neutral-border-1',
  cascaderOptionHeight: 'Size-16',
  cascaderOptionPaddingX: 'Padding-4',
  cascaderOptionPaddingY: 'Padding-1',
  cascaderOptionActiveColor: 'Brand-6',
  cascaderOptionActiveBackgroundColor: 'Brand-1',
  cascaderOptionInnerPaddingX: 'Padding-8',
  cascaderOptionInnerPaddingY: 'Padding-5',
  cascaderOptionInnerPaddingRight: 'Size-15',
  cascaderOptionInnerBorderRadius: 'Radius-2',
  cascaderOptionIconColor: 'Neutral-text-4',
  cascaderOptionHoverBackgroundColor: 'Neutral-fill-2',
  cascaderOptionDisabledColor: 'Neutral-text-2',
  cascaderOptionDisabledBackgroundColor: 'Neutral-fill-1',
  cascaderMorePaddingX: 'Padding-16',
  cascaderMorePaddingY: 'Padding-14',
  cascaderHeaderPadding: 'Padding-8',
  cascaderHeaderBorderColor: 'Neutral-border-1',
  cascaderGroupTitleFontColor: 'Neutral-text-3',
  cascaderGroupTitleFontSize: '12/regular',
  cascaderGroupTitlePaddingX: 'Padding-12',
  cascaderGroupTitlePaddingY: 'Padding-6',
  cascaderColumnPadding: 'Padding-8',
  cascaderColumnOptionMargin: 'Margin-8',
  cascaderListBorderColor: 'Neutral-border-1',
};

export default cascaderTokens;
